
<template>
<div>
  <policy-koCurrent ></policy-koCurrent>
  <policy-koOld ></policy-koOld>    
  </div>
</template>


<script>
import policyKOCurrent from "./koCurrent"
import policyKOOLD from "./koOld"

export default {
  components: {
    'policy-koOld' :policyKOOLD,
    'policy-koCurrent' :policyKOCurrent,
  },
  data() {
    return {
     };
  },
  created() {


  },
  methods: {

  }
};
</script>

<style scoped>

</style>


    
    
   
   
   
    
   